import { createFileRoute, redirect } from '@tanstack/react-router';

import { userStore } from '@/stores/user.store';
import { Routes } from '@/types/routes';

export const Route = createFileRoute('/_authenticated/playground/canvas')({
  beforeLoad() {
    if (userStore.isInternalUser) return;

    throw redirect({
      to: Routes.Chats as string,
      replace: true,
    });
  },
});
